import FilledArrowDownIcon from 'components/Common/SvgIcons/FilledArrowDownIcon'
import { isUndefined } from 'lodash'
import React, { useEffect, useState } from 'react'

interface IAppExpandItemsAccordion {
  title: string
  open: boolean
  onOpen: () => void
  onClose?: () => void
  children: React.ReactNode
}

export const AppExpandItemsAccordion: React.FC<IAppExpandItemsAccordion> = ({
  title,
  open,
  onOpen,
  onClose,
  children,
}) => {
  const [isOpen, setOpen] = useState(open)

  const handleToggle = () => {
    setOpen(!isOpen)
    if (!isOpen) {
      onOpen()
    } else {
      if (onClose) onClose()
    }
  }

  useEffect(() => {
    if (!isUndefined(open)) {
      setOpen(open)
    }
  }, [open])

  return (
    <div className="">
      <div className="flex items-center cursor-pointer" onClick={handleToggle}>
        <span className="space-x-2 text-primary text-base font-bold">{title}</span>
        <FilledArrowDownIcon className={isOpen ? 'rotate-180' : ''} />
      </div>
      {isOpen && <>{children}</>}
    </div>
  )
}

AppExpandItemsAccordion.defaultProps = {
  open: false,
  onClose: () => {},
}
